<template>
  <FaIcon :icon="['fas', 'location-crosshairs']" />
</template>
